<div id="overlay">
    <div *ngIf="apiCallInProgress" style="display: flex;justify-content: center;align-items: center;margin-top: 40vh;">
      <mat-spinner class="spinnerdiv"></mat-spinner>
  </div>
</div>

<!-- <ng-container *ngIf="userData">
  <privacy-container [data]="containerData$ | async"
    (privacyStatus)="privacyStatus($event)">
  </privacy-container>
  
<app-toolbar></app-toolbar>

<router-outlet></router-outlet>
<ng-container *ngIf="localBasicAuth ;else normalFooter"> <app-footer *ngIf="showFooter"></app-footer></ng-container>
<ng-template #normalFooter><app-footer ></app-footer></ng-template>



</ng-container> -->
<ng-container *ngIf="userData">
  <privacy-container [data]="containerData$ | async" (privacyStatus)="privacyStatus($event)"></privacy-container>
  
  <app-toolbar></app-toolbar>

  <router-outlet></router-outlet>

  <!-- Change this section to conditionally show the footer -->
  <ng-container *ngIf="!localBasicAuth || (localBasicAuth && !isLoginPage)">
    <app-footer *ngIf="showFooter"></app-footer>
  </ng-container>

  <ng-template #normalFooter><app-footer></app-footer></ng-template>
</ng-container>
